import React from "react";
import { useTranslation } from "react-i18next";
import { NavLink } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { removeNotification } from '../../../features/auth/authSlice';
import { useMarkNotificationReadMutation } from '../../../features/user/userApiSlice';

const NotificationListItem = (props) => {
    const { t } = useTranslation();
    const dispatch = useDispatch();
    const [markRead] = useMarkNotificationReadMutation();
    const { id, clientName, masterName, jobTitle, title, description: notificationLocation, jobFK, type, proposedPayment, currency, executionTime, minPayment, maxPayment, isSmall } = props;
    const isCandidate = type === 'master_applied';
    const isNewJob = type === 'job_created';
    const isCompletion = type === 'job_completed';
    const notificationUrl = isCandidate
        ? `/client-office/manage-jobs/manage-candidates?id=${jobFK}`
        : `/master-office/job/${encodeURIComponent(jobTitle || 'job')}/${jobFK}`;

    const onOpen = async () => {
        await markRead(id).unwrap();
        dispatch(removeNotification(id));
    };

    return <li className="notifications-not-read">
        <NavLink onClick={onOpen} to={notificationUrl} state={{ id: jobFK, name: jobTitle, page: isCandidate ? 'ManageCandidates' : 'Job' }}>
            <span className="notification-icon"><i className="icon-material-outline-group"></i></span>
            <span className="notification-text">
                {isCandidate ? <>
                    <strong>{masterName}</strong> {t(title)} <span className="color">{jobTitle}</span>
                    <span> · {proposedPayment} {currency}{executionTime ? ` · ${executionTime}` : ''}</span>
                </> : isNewJob ? <>
                    <strong>{clientName}</strong> {t(title)} <span className="color">{jobTitle}</span>
                    {notificationLocation && <span> · {notificationLocation}</span>}
                    <span> · {minPayment}–{maxPayment} {currency}</span>
                </> : isCompletion ? <>
                    <strong>{clientName}</strong> {t(title)} <span className="color">{jobTitle}</span>
                    <span> · {'★'.repeat(Number(props.rating || props.description || 0))}</span>
                </> : <>
                    <strong>{clientName}</strong> {t(title)} <span className="color">{jobTitle}</span>
                </>}
            </span>
            {!isSmall &&
            <div className="buttons-to-right">
                <a href="#" className="button ripple-effect ico" title="Mark as read" data-tippy-placement="left"><i className="icon-feather-check-square"></i></a>
            </div>}
        </NavLink>
    </li>;
};

export default NotificationListItem;
